module.exports = __webpack_public_path__ + "media/images/official/referral_step_start-2bd07d6419f93e34706bd40ca63b836f.webp";